module.exports = __webpack_public_path__ + "media/evolve/assets/icons/planned/mic-9d3a3692ac864305a003849516786829.svg";